import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { KbMyBulletinBoardComponent } from './kb-my-bulletin-board/kb-my-bulletin-board.component';
import { FormsModule } from '@angular/forms';
import { KbMyAccountLeftSideNavModule } from '../my-account-left-sidenav/my-account-left-sidenav.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';



@NgModule({
    declarations: [KbMyBulletinBoardComponent],
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        IconModule,
        I18nModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MediaModule,
        FormsModule,
        MatExpansionModule,
        KbMyAccountLeftSideNavModule,
        ConfigModule.withConfig({
            cmsComponents: {
                MyBulletinBoardFlexComponent: {
                    component: KbMyBulletinBoardComponent,
                    guards: [SecureGuard, AuthGuard]
                },
            }
        } as CmsConfig)
    ],
})
export class KbMyBulletinBoardModule { }
